export const APP_ERROR = 'APP_ERROR';
export const APP_INFO = 'APP_INFO';
export const DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION';
export const READ_NOTIFICATION = 'READ_NOTIFICATION';
